/**
 * Applies the decimal and thousands separators.
 */
export default function numberWithApostrophe(x: number | string | undefined): string | undefined {
  if (x !== undefined) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }
  return x;
}
